import { OrderBaseUrls } from '@ravago/shared/page-data/models/elements';

import { useQuery } from '@tanstack/react-query';

import { getOrderBaseUrls } from '../url.utils';

interface UseOrderBaseUrlsParams {
  language: string;
}

const defaultOrderBaseUrls: OrderBaseUrls = {
  callOffAgreementBaseUrl: '',
  productBaseUrl: '',
  orderDetailBaseUrl: '',
  orderOverviewBaseUrl: '',
  shipmentBaseUrl: '',
  myProductsAndPricesBaseUrl: ''
};

export const useOrderBaseUrls = ({ language }: UseOrderBaseUrlsParams) => {
  const {
    data: orderBaseUrls,
    isLoading,
    error
  } = useQuery({
    queryKey: ['orderBaseUrls', language],
    queryFn: () => getOrderBaseUrls(language),
    staleTime: 1000 * 60 * 30 // Cache for 30 minutes since URLs don't change often
  });

  return {
    orderBaseUrls: orderBaseUrls ?? defaultOrderBaseUrls,
    isLoading,
    error
  };
};
